var $ = jQuery; var site = site || {}; var generic = generic || {}; var rb = rb || {}; var prodcat = prodcat || {};
